import { useContext } from 'react'
import { storeContext } from 'contexts/storeContext'
import { pendingSupportReqCount, getRequestList, getSupportRequestDetails, addRequestDetail, closeSupportRequest } from 'api/supportRequest'
import useAlert from './useAlert'
const useStore = () => {
  let detailStatus
  const [state, dispatch] = useContext(storeContext)
  const { openAlert } = useAlert()
  // COUNT SUPPORT REQUESTS
  const countWaitingSupportRequests = async () => {
    try {
      const { P_RESULT_CODE, P_RESULT_MESSAGE, RESULT } = await pendingSupportReqCount()
      if (P_RESULT_CODE === 0) {
        updateWaitingSupportRequests(RESULT[0].pending_req_count)
      } else {
        openAlert('error', true, P_RESULT_MESSAGE)
      }
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }
  const updateWaitingSupportRequests = (s_count) => {
    dispatch({ type: 'UPDATE_WAITING_SUPPORT_COUNT', payload: s_count })
  }
  // GET SUPPORT REQUESTS
  const listSupportRequests = async () => {
    try {
      const {
        data: { P_RESULT_CODE, P_RESULT_MESSAGE, RESULT },
      } = await getRequestList()
      if (P_RESULT_CODE === 0) {
        // console.info('result', RESULT)
        dispatch({ type: 'LIST_SUPPORT_REQUESTS', payload: RESULT })
      } else {
        openAlert('error', true, P_RESULT_MESSAGE)
      }
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }
  const clearSupportRequests = () => {
    dispatch({ type: 'CLEAR_SUPPORT_REQUESTS' })
  }
  // Support Request Detail
  const getSupportRequestDetail = async (id_user_support) => {
    try {
      const {
        data: { P_RESULT_CODE, P_RESULT_MESSAGE, RESULT },
      } = await getSupportRequestDetails({ id_user_support })
      // FIXME: gelen veriler daha temiz olmalı JSON.parse(RESULT[0]?.data)[0]
      const cleanResult = JSON.parse(RESULT[0]?.data)[0]

      if (P_RESULT_CODE === 0) {
        dispatch({ type: 'GET_SUPPORT_REQUEST_DETAIL', payload: cleanResult })
        detailStatus = cleanResult
      } else {
        openAlert('error', true, P_RESULT_MESSAGE)
      }
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }
  const addSupportRequestDetail = async (db) => {
    try {
      const { P_RESULT_CODE, P_RESULT_MESSAGE } = await addRequestDetail(db)
      if (P_RESULT_CODE === 0) {
        await getSupportRequestDetail(db.id_user_support)
        await countWaitingSupportRequests()
        let newArray = [...state.supportRequests]
        const changedIndex = newArray.findIndex((item) => item.id === state.supportRequestDetail.id)
        if (changedIndex >= 0) {
          // console.log('state.supportRequestDetail', state.supportRequestDetail)
          // console.log('değişen', detailStatus)
          // newArray[changedIndex] = { ...state.supportRequestDetail, state: detailStatus  }
          newArray[changedIndex] = detailStatus
          dispatch({ type: 'LIST_SUPPORT_REQUESTS', payload: newArray })
        }
      } else {
        openAlert('error', true, P_RESULT_MESSAGE)
      }
    } catch (error) {
      openAlert('error', true, error.message)
    }
  }
  const clearSupportRequestDetail = () => {
    dispatch({ type: 'CLEAR_SUPPORT_REQUEST_DETAIL' })
  }
  // close Support Request

  const closeSupportReq = async (prm) => {
    try {
      const { P_RESULT_CODE, P_RESULT_MESSAGE } = await closeSupportRequest(prm)
      if (P_RESULT_CODE === 0) {
        await countWaitingSupportRequests()
        let newArray = [...state.supportRequests]
        const changedIndex = newArray.findIndex((item) => item.id === state.supportRequestDetail.id)
        if (changedIndex >= 0) {
          newArray[changedIndex] = { ...state.supportRequestDetail, state: prm.state }
          dispatch({ type: 'LIST_SUPPORT_REQUESTS', payload: newArray })
        }
        return true
      } else {
        openAlert('error', true, P_RESULT_MESSAGE)
        return false
      }
    } catch (error) {
      openAlert('error', true, error.message)
      return false
    }
  }

  return {
    storeState: state,
    countWaitingSupportRequests,
    updateWaitingSupportRequests,
    listSupportRequests,
    clearSupportRequests,
    getSupportRequestDetail,
    clearSupportRequestDetail,
    addSupportRequestDetail,
    closeSupportReq,
  }
}
export default useStore
